let $reviewsSlider = $(".reviews-slider"),
	$reviewsSliderDots = $(".reviews__slider-dots"),
	sliderSettings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		infinite: false,
		fade: true,
		responsive: [
			{
				breakpoint: 767,
			},
		],
		appendDots: $reviewsSliderDots,
		appendArrows: $(".reviews__slider-nav"),
		nextArrow:
			'<button type="button" class="reviews__slider-arrow reviews__slider-arrow_next"></button>',
		prevArrow:
			'<button type="button" class="reviews__slider-arrow reviews__slider-arrow_prev"></button>',
	};

function setBoundries(slick, state) {
	if (state === "default") {
		$reviewsSliderDots
			.find("ul.slick-dots li")
			.eq(6)
			.addClass("n-small-1");
	}
}
/* eslint-disable */
let maxDots = 6,
	transformCount = 0,
	transformIntervalNext,
	transformIntervalPrev,
	transformDirection;

if ($(window).width() > 767) {
	transformIntervalNext = -30;
	transformIntervalPrev = 30;
	transformDirection = "translateY";
} else {
	transformIntervalNext = -24;
	transformIntervalPrev = 24;
	transformDirection = "translateX";
}

$(window).resize(function() {
	if ($(window).width() > 767) {
		transformIntervalNext = -30;
		transformIntervalPrev = 30;
		transformDirection = "translateY";
	} else {
		transformIntervalNext = -24;
		transformIntervalPrev = 24;
		transformDirection = "translateX";
	}
});

$reviewsSlider.on("init", function(event, slick) {
	$reviewsSliderDots
		.find("ul.slick-dots")
		.wrap("<div class='slick-dots-container'></div>");
	$reviewsSliderDots
		.find("ul.slick-dots li")
		.each(function(index) {
			$(this).addClass("dot-index-" + index);
			$(this).attr("data-index", index);
		});

	$reviewsSliderDots
		.find("ul.slick-dots")
		.css("transform", transformDirection + "(0)");
	setBoundries($(this), "default");
});
$reviewsSlider.on("breakpoint", function(event, slick) {
	$(".slick-dots-container").remove();
	$reviewsSliderDots
		.find("ul.slick-dots")
		.wrap("<div class='slick-dots-container'></div>");
	$reviewsSliderDots
		.find("ul.slick-dots li")
		.each(function(index) {
			$(this).addClass("dot-index-" + index);
			$(this).attr("data-index", index);
		});

	transformCount = 0;
	$reviewsSlider.slick("slickGoTo", 0)

	$reviewsSliderDots
		.find("ul.slick-dots")
		.css("transform", transformDirection + "(0)");
	setBoundries($(this), "default");
});

function dotsTranslater(currentSlide, nextSlide, markerClassInMove, markerClassAgainstMove, markerClassAgainstMovePosition ) {
	let transformValue = nextSlide > currentSlide ? transformIntervalNext : transformIntervalPrev,
		clearClassIndex = nextSlide > currentSlide ? markerClassAgainstMovePosition - 1 : nextSlide - 1,
		addClassIndex = nextSlide > currentSlide ? nextSlide + 1 : nextSlide - 1;

	if (
		$reviewsSliderDots
			.find("ul.slick-dots li.dot-index-" + nextSlide)
			.hasClass(markerClassInMove)
	) {
		transformCount = transformCount + transformValue;
			$reviewsSliderDots
				.find("ul.slick-dots li.dot-index-" + nextSlide)
				.removeClass(markerClassInMove);
			$reviewsSliderDots
				.find("ul.slick-dots li.dot-index-" + addClassIndex)
				.addClass(markerClassInMove);
			$reviewsSliderDots
				.find("ul.slick-dots")
				.css(
					"transform",
					transformDirection + "(" + transformCount + "px)"
				);

			$reviewsSliderDots
				.find("ul.slick-dots li")
				.eq(clearClassIndex)
				.removeClass(markerClassAgainstMove);
			$reviewsSliderDots
				.find("ul.slick-dots li")
				.eq(markerClassAgainstMovePosition)
				.addClass(markerClassAgainstMove);
	}
}

$reviewsSlider.on("beforeChange", function(
	event,
	slick,
	currentSlide,
	nextSlide
) {		
	var totalCount = $reviewsSliderDots.find(".slick-dots li").length;
	if (totalCount > maxDots) {
		if (nextSlide > currentSlide) {
			let pPointer = nextSlide - 6;
			dotsTranslater(currentSlide, nextSlide, "n-small-1", "p-small-1", pPointer);
		} else {
			let pPointer = nextSlide + 6;
			dotsTranslater(currentSlide, nextSlide, "p-small-1", "n-small-1", pPointer);
		}
	}
});

$reviewsSlider.slick(sliderSettings);


// WEBPACK FOOTER //
// ./scripts/modules/reviews.js